import { defaultProps } from 'recompose';

import AutocompleteMultipleBase from '@/components/AutocompleteMultipleBase';
import AutocompleteAPI from '@/containers/AutocompleteAPI';

export default defaultProps({ Autocomplete: AutocompleteMultipleBase })(
  AutocompleteAPI,
);
